import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { AnimatePresence, motion } from 'framer-motion';
import './HomeProjects.css';
import img1 from '../../assets/Home/Project/Img1.jpeg';
import img2 from '../../assets/Home/Project/Img2.jpeg';
import img3 from '../../assets/Home/Project/Img3.jpeg';
import img4 from '../../assets/Home/Project/Img4.jpeg';


const projects = [
  {
    id: "01",
    title: "50kW, RPCAU, Bihar, 1",
    description: "Engineering, design, and turnkey installation of a 50kW rooftop solar PV system at RPCAU, Bihar, providing reliable and sustainable clean power.",
    image: img1,
    link: "/projects/solar-bess"
  },
  {
    id: "02",
    title: "5kW, Solar Tree, Pusa, 1",
    description: "Design and deployment of an innovative 5kW Solar Tree in Pusa, Bihar, maximizing clean energy generation with minimal footprint and modern aesthetics.",
    image: img2,
    link: "/projects/solar-hybrid"
  },
  {
    id: "03",
    title: "30kW, Leh Ladakh, 1",
    description: "Installation and commissioning of a 30kW high-altitude solar power system in Leh Ladakh, engineered to withstand extreme temperatures and rugged terrain.",
    image: img3,
    link: "/projects/solar-epc"
  },
  {
    id: "04",
    title: "30kW, Leh Ladakh, 2",
    description: "High-altitude 30kW rooftop solar installation in Leh Ladakh, delivering robust, decentralized solar energy to power local infrastructure.",
    image: img4,
    link: "/projects/solar-ipp"
  }
];

const HomeProjects = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % projects.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % projects.length);
  };

  return (
    <section className="home-projects-section">
      <Container>
        <Row className="align-items-start">
          {/* Left Content */}
          <Col lg={5} className="project-text-col">
            <div className="section-tag">
              Our Project
            </div>
            <h2 className="project-main-heading">
              Selected Projects & <br /> Expertise
            </h2>
            <div className="project-desc-wrap">
              <p className="project-description">
                From large-scale solar and hybrid projects to wind, BESS, and green energy initiatives, Dazbog supports projects across the renewable energy lifecycle.
              </p>
              
              <div className="project-nav-arrows">
                <button className="nav-btn prev" onClick={handlePrev} aria-label="Previous Project">
                  <FiArrowLeft />
                </button>
                <button className="nav-btn next" onClick={handleNext} aria-label="Next Project">
                  <FiArrowRight />
                </button>
              </div>
            </div>
          </Col>

          {/* Right Image Card */}
          <Col lg={7} className="project-card-col">
            <div className="project-main-card">
              <AnimatePresence mode="wait">
                <motion.div 
                   key={activeIndex}
                   initial={{ opacity: 0, x: 20 }}
                   animate={{ opacity: 1, x: 0 }}
                   exit={{ opacity: 0, x: -20 }}
                   transition={{ duration: 0.5 }}
                   className="project-card-inner"
                >
                  <div className="project-card-image">
                    <img 
                      src={projects[activeIndex].image} 
                      alt={projects[activeIndex].title} 
                    />
                    <div className="card-overlay">
                      <div className="card-content-bottom">
                        <h3 className="card-title2">{projects[activeIndex].title}</h3>
                        <p className="card-desc2">
                          {projects[activeIndex].description}
                        </p>
                        <div className="card-footer">
                          <span className="read-more-link" style={{ cursor: "pointer" }}>
                            Read more <FiArrowRight className="link-icon" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomeProjects;
